import { createFeature, createReducer, on } from '@ngrx/store';
import { IdleActions } from '../../actions/idle/idle.actions';
import { UserActions } from '@store/actions/user/user.actions';

export const idleFeatureKey = 'idle';

export interface State {
 idleWarning: boolean,
 idleValue: number,
}

export const initialState: State = {
  idleWarning: false,
  idleValue: 0
};

export const reducer = createReducer(
  initialState,

  on(IdleActions.idleStart, (state, action) => ({
    ...state,
   idleWarning: true
  })),
  on(IdleActions.idleEnd, (state, action) => ({
    ...state,
   idleWarning: false,
    idleValue: 0
  })),
  on(IdleActions.timeOutWarning, (state, action) => ({
    ...state,
    idleValue: state.idleValue + 1
  })),
  on(UserActions.logoutButtonPressed, (state, action) => ({
    ...state,
    idleWarning: false,
    idleValue: 0,
  }))

);

export const idleFeature = createFeature({
  name: idleFeatureKey,
  reducer,
});

